<dialog-header
  title="Voucher Design Library"
  (onClose)="matDialogRef.close()"
></dialog-header>

<div mat-dialog-content>
  <loader [loading]="loading"></loader>

  <div class="design-grid">
    <div *ngFor="let design of designs" class="design-item">
      <img [src]="design.url" [alt]="design.name" />
      <div class="design-name">{{ design.name }}</div>
    </div>
  </div>
</div>
